import React from 'react';
import styled from "styled-components";
import {Routes, Route, useLocation} from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

//importing components
import Layoutsvg from '../components/Layoutsvg';
import Navbar from '../components/Navbar';
import Menu from '../components/Menu';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Projects from './Projects';
import AboutDetail from './AboutDetail';
import ProjectDetail from './ProjectsDetail';


function Layout() {

  const location = useLocation();

  return (
    <LayoutDiv>
        {/* <Layoutsvg/> */}
        <Navbar/>
        {/* <Menu/> */}
        <AnimatePresence exitBeforeEnter>
          <Routes location={location} key={location.pathname} >
            <Route path='/' element={<Home/>} />
            <Route path='/about' element={<About/>} />
            <Route path='/contact' element={<Contact/>} />
            <Route path='/projects' element={<Projects/>} />
            <Route path='/aboutdetail' element={<AboutDetail/>} />
            <Route path='/projectsdetail' element={<ProjectDetail/>} />
          </Routes>
        </AnimatePresence>

    </LayoutDiv>
  );
}


const LayoutDiv = styled.div`
    position: relative;
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(to bottom, #062040, #071e3a, #071b35, #07172a, #05101d, #030c17 );
`;

export default Layout;